import { NavLink } from 'react-router-dom';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  className: string;
}

export default function Navigation({ className = '' }: Props) {
  const { t } = useTranslation();
  const [openedDropdown, setOpenedDropdown] = useState<number | null>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (headerRef.current && !headerRef.current.contains(event.target as Node)) {
        setOpenedDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [headerRef]);

  const navigation = useMemo(
    () => [
      {
        text: t('Earn'),
        children: [
          {
            text: t('Tasks'),
            to: '/tasks',
          },
          {
            text: t('Campaigns'),
            to: '/campaigns',
          },
        ],
      },
      {
        text: t('Explore'),
        children: [
          {
            text: t('Brands'),
            to: '/projects',
          },
          {
            text: t('Clans'),
            to: '/clans',
          },
          {
            text: t('Leaderboards'),
            to: '/leaderboards',
          },
          {
            text: t('How It Works'),
            to: '/how-it-works',
          },
        ],
      },
    ],
    [t],
  );

  return (
    <div ref={headerRef} className={`flex items-start gap-x-6 xl:gap-x-10 mt-0 ${className}`}>
      {navigation.map((link, index) => (
        <div
          onMouseEnter={() => setOpenedDropdown(index)}
          onMouseLeave={(event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
              setOpenedDropdown(null);
            }
          }}
          key={index}
          className='relative h-max flex items-center justify-center pb-1'
        >
          <div
            // onClick={() => setOpenedDropdown((past) => (past === index ? null : index))}
            className='flex items-center justify-center cursor-pointer'
          >
            <div className='text-base leading-6 font-medium text-blue-gray-800 dark:text-white'>
              {link.text}
            </div>
            <p className='icon-arrow-left text-lg -rotate-90 flex items-center justify-center -mt-1.5 dark:text-white' />
          </div>

          {openedDropdown === index && (
            <div
              ref={dropdownRef}
              // onMouseEnter={() => setOpenedDropdown(index)}
              onMouseLeave={() => setOpenedDropdown(null)}
              className='w-24 absolute z-10 top-7 rounded bg-white dark:bg-[#202020] border border-slate-200 dark:border-[#5E5331] text-xs text-slate-800 dark:text-white'
            >
              {link.children?.map((child) => (
                <>
                  <Link
                    to={child.to}
                    className='flex text-center items-center justify-center py-2.5 cursor-pointer hover:bg-slate-100 dark:hover:bg-[#2B2B2B] transition-colors duration-300'
                  >
                    {child.text}
                  </Link>
                  <div className='mx-3.5 h-[1px] bg-slate-200 dark:bg-[#5E5331] last:hidden' />
                </>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* {navigation.map(({ text, ...item }) => ( */}
      {/*   <NavLink */}
      {/*     {...item} */}
      {/*     className={({ isActive }: { isActive: boolean }) => */}
      {/*       'font-medium transition-color text-base text-slate-800' */}
      {/*     } */}
      {/*     key={item.to} */}
      {/*   > */}
      {/*     {text} */}
      {/*   </NavLink> */}
      {/* ))} */}
    </div>
  );
}
